import { render, staticRenderFns } from "./comHeader.vue?vue&type=template&id=0cd130ac"
import script from "./comHeader.vue?vue&type=script&lang=js"
export * from "./comHeader.vue?vue&type=script&lang=js"
import style0 from "./comHeader.vue?vue&type=style&index=0&id=0cd130ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports